function MarqueeBand({ items }) {
  const repeatedItems = [...items, ...items];

  return (
    <section className="marquee-band" aria-label="Направления Chinatao">
      <div className="marquee-track">
        {repeatedItems.map((item, index) => (
          <span key={`${item}-${index}`}>{item}</span>
        ))}
      </div>
    </section>
  );
}

export default MarqueeBand;
